<!--  -->
<template>
  <div class="contianer">
    <div class="con">
      <img
        class="bgimg"
        src="../../assets/images/h5_221227/1080_01.jpg"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_221227/1080_02.jpg"
        alt=""
        @click="goto('20945')"
      />
       <img
        class="bgimg"
        src="../../assets/images/h5_221227/1080_03.jpg"
        alt=""
        @click="goto('21616')"
      />
       <img
        class="bgimg"
        src="../../assets/images/h5_221227/1080_04.jpg"
        alt=""
        @click="goto('21618')"
      />
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_05.jpg"
            @click="goto('21496')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_06.jpg"
            @click="goto('9937')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_07.jpg"
            @click="goto('21013')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_08.jpg"
            @click="goto('20464')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_09.jpg"
            @click="goto('3134')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_10.jpg"
            @click="goto('20800')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_11.jpg"
            @click="goto('21582')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_12.jpg"
            @click="goto('21717')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_13.jpg"
            @click="goto('10159')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_14.jpg"
            @click="goto('21586')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_15.jpg"
            @click="goto('21231')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_16.jpg"
            @click="goto('18718')"
          />
        </div>
      </div>
     <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_17.jpg"
            @click="goto('21193')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_221227/1080_18.jpg"
            @click="goto('9925')"
          />
        </div>
      </div>
      <img
        class="bgimg"
        src="../../assets/images/h5_221227/1080_19.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goto(id) {
      let position = window.scrollY;
      this.$router.push({ query: { page: position } });
      this.$router.push({
        path: "/productDetails?id=" + id,
      });
    },
  },
  created() {},
  mounted() {
    let recruitScrollY = this.$route.query.page;
    window.scroll(0, recruitScrollY);
  },
};
</script>
<style lang='scss' scoped>
img {
  border: 0;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: 100%;
}
.con {
  .ac1_img,
  .ac2_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
  .ac3_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
}
</style>